export default "__VITE_ASSET__SLmBR_KO__"